import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  FaCcMastercard,
  FaCcPaypal,
  FaCcAmex,
  FaCcVisa,
  FaCcDiscover,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import cyclecircleLogo from "../../img/parts/Cycle-Circle-Logo-White-1.png";
import { setSelectedSupport } from "../../store/slices/supportSlice";

function MobileFooter({ setSelectedSupport }) {
  return (
    <footer className="w-full flex flex-col items-center justify-start bg-gradient-to-b from-blue via-blue to-blue text-white-1 relative overflow-hidden pt-10 pb-[65px]">
      {/* 🌈 Decorative Background Blur */}
      <div className="absolute inset-0 bg-gradient-to-t from-blue/50 via-transparent to-blue/40 blur-3xl pointer-events-none"></div>

      {/* 🔹 Logo Section */}
      <div className="relative z-10 flex flex-col items-center mb-8">
        <img
          loading="lazy"
          src={cyclecircleLogo}
          alt="CycleCircle Logo"
          className="h-[80px] brightness-110 drop-shadow-lg mb-2"
        />
        <p className="text-sm text-white-1/80 font-medium tracking-wide">
          Your Trusted Cycling Partner
        </p>
      </div>

      {/* 🔹 About Us & Support Sections */}
      <div className="w-full flex items-start justify-between px-6 relative z-10 mb-8">
        {/* About Section */}
        <div className="flex flex-col items-start w-[48%]">
          <h3 className="text-lg font-extrabold tracking-wide mb-3 uppercase text-gold">
            About Us
          </h3>
          {[
            { name: "Know About Us", link: "/aboutUs" },
            { name: "Become a Member", link: "/aboutUs" },
            { name: "Exclusively on CC", link: "/refund" },
            { name: "Our Belief System", link: "/our_belief_system" },
            { name: "Privacy Policy", link: "/privacypolicy" },
            { name: "Copyright", link: "/copyright" },
          ].map((item, i) => (
            <Link
              key={i}
              to={item.link}
              className="text-[13px] font-medium text-white-1/80 my-[5px] hover:text-white-1 transition-colors"
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Support Section */}
        <div className="flex flex-col items-start w-[48%]">
          <h3 className="text-lg font-extrabold tracking-wide mb-3 uppercase text-gold">
            Support
          </h3>
          {[
            { name: "Track My Order", val: 1 },
            { name: "Returns & Refunds", val: 5 },
            { name: "User Agreement", val: 4 },
            { name: "Data Privacy Policy", val: 3 },
            { name: "Shipping Policy", val: 2 },
          ].map((item, i) => (
            <Link
              key={i}
              to="/support"
              onClick={() => setSelectedSupport(item.val)}
              className="text-[13px] font-medium text-white-1/80 my-[5px] hover:text-white-1 transition-colors"
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/blog"
            className="text-[13px] font-medium text-white-1/80 my-[5px] hover:text-white-1 transition-colors"
          >
            Blog
          </Link>
        </div>
      </div>

      {/* 🔹 Contact Section */}
      <div className="w-full px-6 relative z-10 mb-10">
        <h3 className="text-lg font-extrabold tracking-wide mb-3 uppercase text-gold">
          Contact
        </h3>

        <div className="flex items-start mb-3">
          <LocationOnIcon className="text-[18px] mr-3 mt-[2px]" />
          <p className="text-[13px] font-medium leading-relaxed text-white-1/90">
            <strong className="text-[14px]">
              RADKAAT VENTURES PRIVATE LIMITED
            </strong>
            <br />
            1st Floor, Unit no.124, Paras Trade Centre, Gurgaon Faridabad Road,
            Gwal Pahari, Gurugram, Haryana 122003
            <br />
            <span className="text-[13px] mt-1 block">
              GST: 02AAMCR8372H1Z4
            </span>
          </p>
        </div>

        <div className="flex items-center mb-2">
          <PhoneIcon className="text-[18px] mr-3" />
          <p className="text-[14px] font-semibold">+91-9418696322</p>
        </div>

        <div className="flex items-center">
          <MailIcon className="text-[18px] mr-3" />
          <p className="text-[14px] font-semibold">
            support@cyclecircle.one
          </p>
        </div>
      </div>

      {/* 🔹 Social & Payment Section */}
      <div className="w-full flex flex-col items-center justify-center bg-[var(--color-blue-hover)] py-8 rounded-t-2xl relative z-10 shadow-inner">
        <h3 className="text-lg font-extrabold tracking-wide mb-4 uppercase text-gold">
          Stay Connected
        </h3>

        {/* Social Media */}
        <div className="flex justify-center gap-6 mb-6">
          <Link
            to="https://www.instagram.com/cyclecircle.one"
            target="_blank"
            className="hover:scale-110 transition-transform duration-300"
          >
            <FaInstagram className="text-[24px]" />
          </Link>
          <Link
            to="https://www.facebook.com/profile.php?id=100083101911813&_rdr"
            target="_blank"
            className="hover:scale-110 transition-transform duration-300"
          >
            <FaFacebookF className="text-[22px]" />
          </Link>
          <Link
            to="https://www.youtube.com/@cyclecircle5922"
            target="_blank"
            className="hover:scale-110 transition-transform duration-300"
          >
            <FaYoutube className="text-[24px]" />
          </Link>
        </div>

        {/* Payment Icons */}
        <h3 className="text-base font-bold text-white/90 mb-3">
          Secure Online Payments
        </h3>
        <div className="flex justify-center gap-5 text-[32px] text-white-1/80 mb-6">
          <FaCcVisa />
          <FaCcMastercard />
          <FaCcAmex />
          <FaCcDiscover />
          <FaCcPaypal />
        </div>

        {/* Copyright */}
        <div className="text-center text-[12px] text-white-1/70 font-medium">
          © 2025 Radkaat Ventures Private Limited. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}

const mapDispatchToProps = {
  setSelectedSupport,
};

export default connect(null, mapDispatchToProps)(MobileFooter);
